// extracted by mini-css-extract-plugin
export default {"container":"Pn-z","brandName":"Qn-z","productName":"Rn-z","productNamePdpEnhancements":"Sn-z","breakLongProductName":"Tn-z"};